import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { isSameDay, format } from 'date-fns';
import { getDatesForDateRange } from '@general/dates';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';


const SidebarContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

const SessionDaySidebar = ({ eventStartDate, eventEndDate, activeDay, onDayChange, event }) => {
    const [days, setDays] = useState([]);

    useEffect(() => {
        if (!eventStartDate || !eventEndDate) return;
        const dates = getDatesForDateRange({
            startDate: eventStartDate,
            endDate: eventEndDate,
            dateFormatLong: 'EEEE, MMM d',
            dateFormatShort: 'yyyy-MM-dd',
        });
        setDays(dates);
    }, [eventStartDate, eventEndDate]);

    const activeIndex = days.findIndex(d => isSameDay(d.date, activeDay));
    const totalDays = days.length;

    const goToPrev = () => { if (activeIndex > 0) onDayChange(days[activeIndex - 1].date); };
    const goToNext = () => { if (activeIndex < totalDays - 1) onDayChange(days[activeIndex + 1].date); };

    return (
        <SidebarContainer>
            <a href={event?.url || '#'} className="sessions-back-link">
                <div className="icon-box">
                    <FontAwesomeIcon icon={faChevronLeft} size="xs" />
                </div>
                Back to Event
            </a>

            <div className="sessions-mobile-header-wrapper">
                <div className="sessions-header-label">Schedule for</div>
                <div className="sessions-header-title">{event?.title || 'Event Schedule'}</div>
            </div>

            <div className="sessions-mobile-wrapper">
                <button
                    className="sessions-nav-arrow"
                    onClick={goToPrev}
                    disabled={activeIndex <= 0}
                >
                    <FontAwesomeIcon icon={faChevronLeft} />
                </button>
                <div className="sessions-mobile-date-center">
                    <div className="sessions-day-counter">Day {activeIndex + 1} of {totalDays}</div>
                    <div className="sessions-current-date-label">
                        {activeDay ? format(activeDay, 'EEEE, MMM d') : ''}
                    </div>
                </div>
                <button
                    className="sessions-nav-arrow"
                    onClick={goToNext}
                    disabled={activeIndex >= totalDays - 1 || activeIndex === -1}
                >
                    <FontAwesomeIcon icon={faChevronRight} />
                </button>
            </div>

            <div className="sessions-desktop-wrapper">
                {days.map((day) => (
                    <div
                        key={day.short}
                        className="sessions-date-item"
                        onClick={() => onDayChange(day.date)}
                    >
                        <div className={`sessions-date-text ${isSameDay(day.date, activeDay) ? 'is-active' : ''}`}>
                            {format(day.date, 'MMMM d, yyyy')}
                        </div>
                        <div className="sessions-underline" />
                    </div>
                ))}
            </div>
        </SidebarContainer>
    );
};

SessionDaySidebar.propTypes = {
    eventStartDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    eventEndDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    activeDay: PropTypes.instanceOf(Date),
    onDayChange: PropTypes.func.isRequired,
    event: PropTypes.object
};

export default SessionDaySidebar;
